import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { a as m } from "../../../../index-CROKJrb5.js";
import { c as s, f as c } from "../../../../create-component-CBAeEoQ6.js";
import { CardMeta as f } from "../../CardMeta/index.js";
const d = s(
  "TextCardMeta",
  c(
    ({ children: r, className: t, ...a }, o) => /* @__PURE__ */ e.jsx(
      f,
      {
        ref: o,
        className: m("-cur-mt-1 cur-mb-4", t),
        ...a,
        children: r
      }
    )
  )
);
export {
  d as TextCardMeta
};
//# sourceMappingURL=index.js.map
